module.exports = __webpack_public_path__ + "img/no_venue_selected.6910e9f3.png";